var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPdfPreviewUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 72,
    viewBox: "0 0 106 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 .667c16.077 0 29.46 11.439 32.463 26.676C96.946 28.138 106 37.59 106 49.25c0 12.19-9.893 22.083-22.083 22.083H26.5c-14.62 0-26.5-11.88-26.5-26.5 0-13.647 10.335-24.91 23.63-26.323C29.15 7.91 40.235.667 53 .667zm8.833 57.416V40.417h13.25L53 18.333 30.917 40.417h13.25v17.666h17.666z",
    fill: "#45474A"
  })));
}

export default SvgPdfPreviewUpload;